import styled from 'styled-components'

const InputBlock = styled.div`
  margin-bottom: 10px;
`

const InputWrap = styled.div`
  position: relative;
  z-index: 0;
`

const DropArea = styled.div`
  border: 1px dashed ${props => props.theme.dropZoneBorderColor};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  padding: ${props => props.theme.dropZonePadding};
  cursor: pointer;
  min-height: 55px;
  border-radius: 3px;
  color: ${props => props.theme.dropZoneTitleColor};
  text-align: center;
`

const DropAreaText = styled.span`
  display: block;
  flex: 0 0 100%;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.1em;
`

const DropAreaTitle = styled(DropAreaText)`
  text-transform: uppercase;
  color: ${props => props.theme.dropZoneTitleColor};
  font-weight: 700;
`

const DropAreaSubtitle = styled(DropAreaText)`
  opacity: 0.5;
  color: ${props => props.theme.dropZoneSubtitleColor};
`

export {
  InputBlock,
  InputWrap,
  DropArea,
  DropAreaText,
  DropAreaTitle,
  DropAreaSubtitle,
}
